<template>
    <div class="main">
        <accommodationsBanner></accommodationsBanner>
        <accommodationsComponents></accommodationsComponents>
        <footerComponent></footerComponent>
    </div>
</template>
<script>
import accommodationsBanner from '/components/pc/headerComponent/accommodationsBanner.vue'
import accommodationsComponents from '/components/pc/experience/accommodationsComponents.vue'
import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
export default{
    components:{
        accommodationsBanner,
        accommodationsComponents,
        footerComponent
    }
}
</script>